import { CustomerTypes } from 'src/app/models/delivery.model';
import { RouteAccess } from '@vfde-fe/ngx-lib/models/route-access';
import { Route } from '@vfde-fe/ngx-lib/models/route-model';
import { RouteTracking } from '@vfde-fe/ngx-lib/models/route-tracking';
import { config } from 'src/config/pages-config';
import { SetCustomerDetails } from '../../redux/actions/customer-details.actions';
import { CustomerTypesEnum, ProcessTypes } from '../../models/customer-details.model';

/** WORDING_FILES */
export const WORDING_FILES = {
    defaultWording: 'defaultWording',
    deWording: 'deWording',
};
/** MODULE_NAMES  */
export const MODULE_NAMES = {
    LOGIN: 'login',
    SIM_HARDWARE_REVOCATION: 'simHardwareRevocation',
    CONFIRMATION: 'confirmation',
    CONFIRMATION_ENTERPRISE: 'confirmationEnterprise',
    WINBACK: 'winback',
    DEFECT_RETURN: 'defectReturn',
    SECOND_DELIVERY: 'secondDelivery',
    OPEN_QUESTIONS: 'openQuestions',
    SALES_AGENT: 'salesAgent',
    SERVICE_AGENT: 'serviceAgent',
    ACCESSORIES: 'accessories',
    REVIEW: 'review',
    DSL_REVOCATION_OPTIONS: 'dslRevocationOptions',
    OVERVIEW: 'overview',
    LANDING_PAGE: 'landingPage',
    UM_VKD_CONTRACT_CANCELLTION: 'cancelContract',
    TERMINATION: 'termination',
    RETURN_DEVICES:'returnDevices',
    REVOCATION: 'revokationKD',
};
/** JWT_NIL_SESSION_HEADRE  */
export const JWT_NIL_SESSION_HEADRE = 'x-nil-jwt-session-token';
/** LOGIN_QUERYPARAMS  */
export const LOGIN_QUERYPARAMS = {
    LOGOUT: 'logout',
    REQUEST_ID: 'request-id',
    POST_CODE: 'post-code',
    ORDER_NUMBER: 'order-id',
    AUTHENTICATION: 'authentication-required',
    ASP: 'ASP',
    TYPE: 'type',
    KABEL: 'kabel',
    VKD: 'vkd',
    UM: 'um',
    DSL: 'dsl',
    LOGOUTQueryParamValue: 'true',
    SHOW_LOGIN: ['deliveryNumber', 'zipCode'],
};
/** LOGIN_ERROR_CODES  */
export const LOGIN_ERROR_CODES = {
    MORE_INFO_CODE: {
        CODE: 'NIL0V0874',
        STATUS: 400,
    },
    FAILED_ATTEMPT: {
        CODE: 'NIL00A007',
        STATUS: 403,
    },
    COMBINATION_ERROR: {
        CODE: 'NIL00A001',
        STATUS: 401,
    },
};
/** USER_TYPES */
export const USER_TYPES = {
    CHANNEL: {
        MOBILE: 'mobile',
        FIXEDNET: 'fixednet',
        OTELO: 'otelo',
        ANY: 'any',
    },
    CUSTOMER_tYPE: {
        ACCESSORIES: 'accessories',
        SIM_ONLY: 'SIM-only',
        CONTRACT_WITH_HW: 'contract-with-HW',
        VVL: 'VVL',
        FN_RENTAL: 'FN-rental',
        FN_PURCHASE: 'FN-purchase',
    },

    MAPPED_CUSTOMER_TYPE: {
        'MOBILE-SIM-ONLY': CustomerTypes.Tiger,
        'MOBILE-CONTRACT-WITH-HW': CustomerTypes.Lion,
        'MOBILE-CONTRACT-WITH-HW-SECOND': CustomerTypes.Snowlion,
        'MOBILE-SIM-ONLY-SECOND': CustomerTypes.Snowtiger,
        'MOBILE-VVL': CustomerTypes.Leopard,
        'MOBILE-VVL-SECOND': CustomerTypes.Snowleopard,
        'ANY-ACCESSORIES': CustomerTypes.Rabbit,
        'FIXEDNET-FN-PURCHASE': CustomerTypes.Python,
        'FIXEDNET-FN-RENTAL': CustomerTypes.Cobra,
        'OTELO-SIM-ONLY': CustomerTypes.Monkey,
        'OTELO-CONTRACT-WITH-HW': CustomerTypes.Panda,
        'MOBILE-GIGACUBE': CustomerTypes.Polarbear,
        'MOBILE-GIGACUBE-SECOND': CustomerTypes.SnowPolarbear,
        'MOBILE-ESIM-CONTRACT-WITH-HW-SECOND': CustomerTypes.SnowNeoLion,
        'MOBILE-ESIM-VVL-WITH-HW-SECOND': CustomerTypes.SnowNeoLeopard,
        'MOBILE-ESIM-CONTRACT-WITH-HW': CustomerTypes.NeoLion,
        'MOBILE-ESIM-VVL-WITH-HW': CustomerTypes.NeoLeopard,
        'ANY-ANY-ENTERPRISE': CustomerTypes.Elephant,
        'ANY-ANY': CustomerTypes.BabyElephant,
        'MOBILE-ESIM-ONLY': CustomerTypes.NeoTiger,
        'MOBILE-ESIM-ONLY-VVL': CustomerTypes.NeoTiger,
    },
};

/** SUPPORTED_SIM_TYPES */
export const SUPPORTED_SIM_TYPES = {
    sim: 'physical_SIM',
    esim: 'eSIM',
};
/** MAPPED_SIM_TYPE */
export const MAPPED_SIM_TYPE = {
    Lion : SUPPORTED_SIM_TYPES.sim,
    Leopard: SUPPORTED_SIM_TYPES.sim,
    Tiger: SUPPORTED_SIM_TYPES.sim,
    NeoLeopard: SUPPORTED_SIM_TYPES.esim,
    NeoLion: SUPPORTED_SIM_TYPES.esim,
    NeoTiger: SUPPORTED_SIM_TYPES.esim,
};
/** ELIGIBLE_USER_SECOND_DELIVERY  */
export const ELIGIBLE_USER_SECOND_DELIVERY = [CustomerTypes.Lion, CustomerTypes.Leopard, CustomerTypes.Tiger, CustomerTypes.NeoLion, CustomerTypes.NeoLeopard, CustomerTypes.Polarbear];
/** TRANSACTIONS_NAMES */
export const TRANSACTIONS_NAMES = {

    REVOKE_SIM_ONLY: 'revoke-SIM-only',
    REVOKE_CONTRACT_WITH_HW: 'revoke-contract-with-HW',
    REVOKE_CONTRACT_WITH_HW_SAME_SUB: 'change-contract-with-HW-same-sub	',
    REVOKE_ACCESSORIES: 'revoke-accessories',
    CHANGE_CONTRACT_WITH_HW_DIFF_SUB: 'change-contract-with-HW-diff-sub',
    REVOKE_CONTRACT_WITH_HW_PURCHASE: 'revoke-contract-with-HW-purchase',
};
/** SECOND_DELIVERY */
export const SECOND_DELIVERY = {
    SECOND: 'SECOND',
};
/** ENTERPRISE */
export const ENTERPRISE: string = 'ENTERPRISE';
/** BASE_URL */
export const BASE_URL = {
    BASE_URL: 'https://eweb8.vfd2-testnet.de',
};
/** QR_CODE */
export const QR_CODE = {
    FILENAME: 'QR-code',
    EXTENSION: '.png',
};
/** SHIPPMENT_DETAILS */
export const SHIPPMENT_DETAILS = {
    FILENAME: 'Frachtschein',
    EXTENSION: '.pdf',
    ERRORCODES: [
        {
            status: '500',
            errorCode: {
                NIL00F311: true,
            },
        }, {
            status: '504',
            errorCode: {
                NIL00T311: true,
            },
        }, {
            status: '400',
            errorCode: {
                'NIL00V311': true,
                'NIL00V002': true,
                'NIL00V001': true,
                'cs-hardware-return.E400T_INVALID_TOKEN': true,
            },
        },
    ],
    shipmentLabelFormat: 'PDF',
    Email_Not_Sent: 'Email not Sent',
    FreightLabelPostfix: '_FreightLabel',
};
/**  TRANSACTION_NAMES */
export const TRANSACTION_NAMES = {
    REVOCATION_TRANSACTION_NAME: 'change-contract-with-HW-same-sub',

};
/** CLIENT */
export const CLIENT = {
    ASP: 'ASP',
};
/** Reason_Code */
export enum Reason_Code {
    W = 27,
    Z = 51,
}
/** productGroup */
export const productGroup = {
    UNBW: 'UNBW',
};
/** SERVICE_AGENT */
export const SERVICE_AGENT = {
    TITLE_KEYS: {
        SECOND_DELIVERY_DIFFERENT: 'secondDeliveryDifferent',
        SIM_HARDWARE: 'simHardware',
        DEFECT_RETURN: 'defectReturn',
    },
};
/** CALLBACK_URL */
export const CALLBACK_URL: string = 'https://eweb8.vfd2-testnet.de/hilfe-support/rueckruf.html#/login?icmp={icmp}&thema={thema}&anonymous=true';

/** CALLBACK_URL_FOR_HW_SIM_REVOCATION */
export const CALLBACK_URL_FOR_HW_SIM_REVOCATION: string = 'https://eweb8.vfd2-testnet.de/hilfe-support/rueckruf.html#/login?thema=retourenportal_rrwunsch&anonymous=true';

/** DATE_FORMATE */
export const DATE_FORMATE: string = 'DD.MM.YYYY';
/** STEPPER_CONFIG */
export const STEPPER_CONFIG = {
    REVOCATION: {
        HARDWARE_AND_SIM: [
            new Route(config.revocation.hardwareAndSimRevocationStepOne.route, config.revocation.hardwareAndSimRevocationStepOne.name, new RouteAccess(),
                new RouteTracking(), 'revocationModule.simHardware.hardwareSelection.stepper.std-headline'),
            new Route(config.revocation.hardwareAndSimRevocationStepTwo.route, config.revocation.hardwareAndSimRevocationStepTwo.name,
                new RouteAccess(), new RouteTracking(), 'revocationModule.simHardware.hardwareDetails.stepper.std-headline'),
            new Route(config.revocation.hardwareAndSimRevocationStepThree.route, config.revocation.hardwareAndSimRevocationStepThree.name, new RouteAccess(),
                new RouteTracking(), 'reviewModule.simHardware.stepper.std-headline'),
                new Route(config.revocation.hardwareAndSimRevocationStepFour.route, config.revocation.hardwareAndSimRevocationStepFour.name, new RouteAccess(),
                    new RouteTracking(), 'revocationModule.simHardware.hardwareSummary.stepper.std-headline'),

        ],
        ACCESSORIES: [
            new Route(config.revocation.accessoriesSelection.route, config.revocation.accessoriesSelection.name, new RouteAccess(),
                new RouteTracking(), 'revocationModule.accessories.stepper.selection-step.std-headline', true),
            new Route(config.revocation.accessoriesSelection.route, config.review.reviewRevokedAccessories.name,
                new RouteAccess(), new RouteTracking(), 'revocationModule.accessories.stepper.review-step.std-headline', true),
        ],
        REVOCATIONSELECTION: [
            new Route(config.revocation.revocationSelection.route, config.revocation.revocationSelection.name, new RouteAccess(),
            new RouteTracking(), 'revocationModule.revocationSelection.stepper.selection-step.std-headline', true),
        new Route(config.revocation.revocationSelection.route, config.review.revocationSelectionReview.name,
            new RouteAccess(), new RouteTracking(), 'revocationModule.revocationSelection.stepper.review-step.std-headline', true),
        ],

    },
    DEFECT: {
        ACCESSORIES: [
            new Route(config.defect.accessories.route, config.defect.accessories.name, new RouteAccess(),
                new RouteTracking(), 'defectReturnModule.accessories.stepper.selection-step.std-headline', true),
            new Route(config.review.reviewDefectAccessoreis.route, config.review.reviewDefectAccessoreis.name,
                new RouteAccess(), new RouteTracking(), 'revocationModule.accessories.stepper.review-step.std-headline', true),
        ],
        SIM_HARDWARE: [
            new Route(config.defect.simHardwareSpecifyingDefect.route, config.defect.simHardwareSpecifyingDefect.name, new RouteAccess(),
                new RouteTracking(), 'defectReturnModule.specifyingDefect.stepName.std-headline', true),
            new Route(config.review.defectSimHardware.route, config.review.defectSimHardware.name, new RouteAccess(),
                new RouteTracking(), 'reviewModule.simHardwareDefect.stepName.std-headline', true),

        ],
        DSL: [
            new Route(config.defect.dsl.route, config.defect.dsl.name, new RouteAccess(),
                new RouteTracking(), 'defectReturnModule.dsl.stepper.selection-step.std-headline', true),
            new Route(config.review.defectDsl.route, config.review.defectDsl.name,
                new RouteAccess(), new RouteTracking(), 'revocationModule.accessories.stepper.review-step.std-headline', true),
        ],
        ENTERPRISE: [
            new Route(config.defect.enterprise.route, config.defect.enterprise.name, new RouteAccess(),
                new RouteTracking(), 'defectReturnModule.enterprise.stepper.selection-step.std-headline', true),
            new Route(config.review.reviewDefectEnterprise.route, config.review.reviewDefectEnterprise.name,
                new RouteAccess(), new RouteTracking(), 'defectReturnModule.enterprise.stepper.review-step.std-headline', true),
        ],
        BabyElephant: [
            new Route(config.defect.babyElephantSelection.route, config.defect.babyElephantSelection.name, new RouteAccess(),
                new RouteTracking(), 'defectReturnModule.accessories.stepper.selection-step.std-headline', true),
            new Route(config.review.reviewDefectBabyElephant.route, config.review.reviewDefectBabyElephant.name,
                new RouteAccess(), new RouteTracking(), 'revocationModule.accessories.stepper.review-step.std-headline', true),
        ],
    },
};
/** DATES */
export const DATES = {
    DATE_FORMAT_YMD: 'YYYY-MM-DD',
    DATE_FORMAT_DMY: 'DD.MM.YYYY',
};
/** POSITION_TYPE */
export enum POSITION_TYPE {
    SIM = 'sim',
    HARDWARE = 'hardware',
}
/** CUSTOMER_tYPES  */
export enum CUSTOMER_tYPES {
    CONSUMER = 'consumer',
    ENTERPTISE = 'enterprise',
}
/** TrackingDefines */
export const TrackingDefines = {
    START_TRANSACTION: 'start',
};
/** POSITION_IDENTIFIERS */
export const POSITION_IDENTIFIERS = {
    IMEI: 'imei',
    SIM_NUMBER: 'simNumber',
    ARTICLE_NUMBER: 'articleNumber',
};
/** PROPERTIES_TO_BE_CLEANED */
export const PROPERTIES_TO_BE_CLEANED = ['imageLink', 'size', 'color',
    'deviceName', 'availabilityDate', 'kit', 'previousTransactions', 'priceList', 'scheduledDeliveryDate',
    'deliveryDate', 'productGroup', 'returnsEntitled', 'tariffName', 'tariffLevel',
    'grossAmount', 'lastAcceptedDate', 'netAmount', 'onlineOrderId', 'orderType', 'tariffCode', 'tariffDescription', 'toImageLink', 'tariffName', 'esims'];
/** SHIMPMENT_DOWNLOAD_PICKED_PROPERTIES */
export const SHIMPMENT_DOWNLOAD_PICKED_PROPERTIES = ['quantity', 'articleName', 'articleNumber',
    'returnReasonCode', 'returnReasonText', 'returnFreeText'];
/** DEFECT_REVOKE */
export const DEFECT_REVOKE = {
    DEFECT: 'defect',
    REVOKE: 'revoke',
    CHANGE: 'change',
};
/** HOTLINE_CMS_PATH */
export const HOTLINE_CMS_PATH = {
    DEFAULT: 'common.hotlineNumbers',
};
/** SECOND_DELIVERY_FEATURE */
export const SECOND_DELIVERY_FEATURE: string = 'SECOND_DELIVERY_FEATURE';
/** RENTED_DSL */
export const RENTED_DSL = 'ZRTL';
/** SALES_AGENT_TEASER */
export const SALES_AGENT_TEASER = {
    ELIGIBLE_USERS_DIFF_VALUES: [CustomerTypes.Snowleopard, CustomerTypes.Snowtiger, CustomerTypes.Snowlion,
        CustomerTypes.SnowNeoLion, CustomerTypes.SnowNeoLeopard, CustomerTypes.SnowPolarbear],
};
/** WINBACK_REDIRECTION_URLS */
export const WINBACK_REDIRECTION_URLS = {
    [CustomerTypes.Tiger]: config.confirmation.simOnlyRevocationConfirmation.route,
    [CustomerTypes.NeoTiger]: config.confirmation.eSimOnlyRevocationConfirmation.route,

};
/** SIM_TYPE */
export const SIM_TYPE = {
    SIM: 'sim',
    ESIM: 'esim',

};
/** DISPLAYED_ITEMS */
export enum DISPLAYED_ITEMS {
    HW_AND_SIM_ONLY = 'HW_AND_SIM_ONLY',
    ACCESSORIES_ONLY = 'ACCESSORIES_ONLY',
}
/** Defect_Reason_Code */
export const Defect_Reason_Code = {
    RETURN_REASON_CODE: '22',
};
/** puis type */
export const SALES_ORDER_TYPE = {
    PUIS: 'puis',
    NOT_APPLICABLE: 'not applicable',
};
/** puis type */
export const PUIS_ORDER_TYPE = {
    PUIS: 'ZPUS',
};
/** ORDER_SUMMARY_CONFIRMATION_NEW_FLOW */
export const ORDER_SUMMARY_CONFIRMATION_NEW_FLOW = {
    QR_CODE: 'qrCode',
    FREIGHT_LABEL: 'freightLabel',
    EMAIL: 'email',
    DOWNLOAD: 'download',
    CLIENT: 'PUIS',
    RECEIVER_ID: {
        DEU: 'deu',
        ZPUS: 'ZPUS',
        RETOUREN_PUIS: 'RetourenPUIS',
        RETOUREN_MOBILE: 'RetourenMobile',
        RECEIVER_ADDRESS_FIXEDNET: 'receiver_address_fixednet',
    },

};
/** Delivery Method of return hardware */
export enum DELIVERY_METHOD {
    digital = 'digital',
    mail = 'mail',
}
/** MEME TYPES */
export const MEME_TYPES = {
    PNG: 'image/png',
    PDF: 'application/pdf',
    JSON: 'application/json',
};
/** SALUTATION */
export const SALUTATION = {
    FIRMA: 'Firma',
};
/** COUNTRY */
export const COUNTRY = 'Deutschland';
/** ACCOUNT LINK */
export const ACCOUNT_LOGIN_LINK = '/meinvodafone/account/login';
/** OPTION_PICKER_TYPES */
export const OPTION_PICKER_TYPES = {
    IMAGE: 'image',
    TEXT: 'text' ,
};
/** CHECKED STATE FOR UI ELEMENTS */
export const CHECKED = 'checked';
/** REDIRECT URL FOR EACH PERSONA SELECTED */
export const REDIRECT_URL_FOR_EACH_PERSONA = {
    [CustomerTypes.Fox]:  config.termination.terminationReasonChooserKD.route,
    [CustomerTypes.Giraffe]: config.revokationKD.umReasonChooser.route,
    [CustomerTypes.Cheetah]: config.returnDevices.kabel.route,
    [CustomerTypes.Camel]: config.revokationKD.capleReasonChooser.route,
    [CustomerTypes.Deer]: config.termination.terminationReasonChooserUM.route,
    [CustomerTypes.Moose]: config.termination.terminationReasonChooserDSL.route,
    [CustomerTypes.Buffalo]: config.revokationKD.dslReasonChooser.route,
    [CustomerTypes.Python]: config.revokationKD.dslReasonChooser.route,
    [CustomerTypes.Cobra]: config.revokationKD.dslReasonChooser.route,
    [CustomerTypes.Dolphine]: config.returnDevices.dsl.route,
};

const  terminationKD = new SetCustomerDetails({
    customerDetails: { persona: CustomerTypes.Fox, processType: ProcessTypes.Termination, customerType: CustomerTypesEnum.VKD },
  });

  const terminationUM = new SetCustomerDetails({
    customerDetails: { persona: CustomerTypes.Deer, processType: ProcessTypes.Termination, customerType: CustomerTypesEnum.UM },
  });

  const terminationDSL = new SetCustomerDetails({
    customerDetails: { persona: CustomerTypes.Moose, processType: ProcessTypes.Termination, customerType: CustomerTypesEnum.DSL },
  });
  const  revokationKD = new SetCustomerDetails({
    customerDetails: { persona: CustomerTypes.Camel, processType: ProcessTypes.Revocation, customerType: CustomerTypesEnum.VKD },
  });

  const revokationUM = new SetCustomerDetails({
    customerDetails: { persona: CustomerTypes.Giraffe, processType: ProcessTypes.Revocation, customerType: CustomerTypesEnum.UM },
  });

  const revokationDSL = new SetCustomerDetails({
    customerDetails: { persona: CustomerTypes.Buffalo, processType: ProcessTypes.Revocation, customerType: CustomerTypesEnum.DSL },
});

const revokationDSLPurchsed = new SetCustomerDetails({
    customerDetails: { persona: CustomerTypes.Python, processType: ProcessTypes.Revocation, customerType: CustomerTypesEnum.DSL },
});

const revokationDSLRental = new SetCustomerDetails({
    customerDetails: { persona: CustomerTypes.Cobra, processType: ProcessTypes.Revocation, customerType: CustomerTypesEnum.DSL },
});

/** CUSTOMER DETAILS ACTION MAPPER FOR SELECTED FLOW */
// LabelOnly Process is Already Terminated/Cancelled UM customer Return HW
/* eslint-disable quote-props */
export const CustomerDetailsMapActions = {
    TERMINATION_KD : terminationKD,
    vkd: terminationKD,
    REVOKATION_UM: revokationUM,
    'widerruf-um': revokationUM,
    REVOKATION_KD: revokationKD,
    'widerruf-vkd': revokationKD,
    TERMINATION_UM: terminationUM,
    um: terminationUM,
    TERMINATION_DSL: terminationDSL,
    dsl: terminationDSL,
    REVOKATION_DSL: revokationDSL,
    REVOKATION_RENTAL_HW_DSL: revokationDSLRental,
    REVOKATION_PURCHASED_HW_DSL: revokationDSLPurchsed,
    'widerruf-dsl': revokationDSL,
     LABELONLY_UM: new SetCustomerDetails( { customerDetails: { persona: CustomerTypes.Cheetah, processType: ProcessTypes.LabelOnly , customerType: CustomerTypesEnum.UM }}),
    LABELONLY_KD: new SetCustomerDetails( { customerDetails: { persona: CustomerTypes.Cheetah, processType: ProcessTypes.LabelOnly , customerType: CustomerTypesEnum.VKD }}),
    LABELONLY_DSL: new SetCustomerDetails( {customerDetails: { persona: CustomerTypes.Dolphine, processType: ProcessTypes.LabelOnly, customerType: CustomerTypesEnum.DSL }}),
};
/* eslint-enable quote-props */

/** STD VALUES FOR OPTION PICKER */
export const OPTION_PICKER_STD_VALUES = {

    DYNAMIC_QUESTIONS_VKD_UM_DSL: {
        REVOKATION_KD: 'REVOKATION_KD',
        REVOKATION_UM: 'REVOKATION_UM',
        LABELONLY_UM : 'LABELONLY_UM',
        LABELONLY_KD : 'LABELONLY_KD',
        TERMINATION_KD: 'TERMINATION_KD',
        TERMINATION_UM: 'TERMINATION_UM',
        TERMINATION_DSL:'TERMINATION_DSL',
        REVOKATION_DSL:'REVOKATION_DSL',
        LABELONLY_DSL:'LABELONLY_DSL',
    },

    LOGIN_OPTIONS_DSL: {
        LOGIN : 'LOGIN',
        WITHOUT_LOGIN : 'WITHOUT_LOGIN',
    },

};
/** ContactNumberStaticValue */
export const ContactNumberStaticValue = 9999999;
/** staticDslPrefix */
export const staticDslPrefix = '000';

/** TERMINATION OPTIONS KEY FOR DEER/FOX PERSONAS */
export const TERMINATION_OPTIONS_KEY = {

    CANCEL_THERE_DEATH : 'cancelThereDeath',
    CANCEL_HAVE_QUESTIONS: 'cancelHaveQuestions',
    CANCEL_TARIFF_SATISFACTION : 'cancelTariffSatisfaction',
    CANCEL_MARKETING_ONE: 'cancelMarketingOne',
    CANCEL_MARKETING_TWO: 'cancelMarketingTwo',
    CANCEL_OTHER_REASON: 'cancelOtherReason',
};

/** TERMINATION REASONS OPTIONS KEY FOR DEER/FOX PERSONAS */
export const REASON_OPTIONS_KEY ={
    cancelHaveQuestions: 'haveQuestions',
    cancelTariffSatisfaction: 'tariffSatisfaction',
    cancelMarketingOne: 'marketingOne',
    cancelOtherReason: 'otherReason',
}


/** TERMINATION REASONS OPTIONS KEY FOR MOOSE PERSONA */
export const REASON_OPTIONS_KEY_DSL ={
    cancelHaveQuestions: 'haveQuestions',
    cancelMarketingOne: 'marketingOne',
    cancelMarketingTwo: 'marketingTwo',
    cancelOtherReason: 'otherReason',
}

/** REVOCATION OPTIONS KEY FOR GIRAFFE/CAMEL PERSONAS */
export const REVOCATION_OPTIONS_KEY = {

    CANCELTECHNICALPROBLEMS : 'cancelTechnicalProblems',
    CANCELTARIFFPROBLEMS: 'cancelTariffProblems',
    CANCELHAVEQUESTIONS : 'cancelHaveQuestions',
    CANCEL_MARKETING_ONE: 'cancelMarketingOne',
    CANCELMARKETINGTWO: 'cancelMarketingTwo',
    CANCELOTHERREASON: 'cancelOtherReason',
};
/** COMPONENTS_IDS */
export const COMPONENTS_IDS = {
    LANDING_PAGE_IDS: {
      mobile: 'login',
      accessories: 'login',
      kabel: 'dynamicQuestionContainer',
      dsl: 'dynamicQuestionContainerDSL',
    },
    DYNAMIC_COMPONENT_IDS: {
      childrenQuestionsContainer: 'childrenQuestionsContainer',
    },
  };
/** component list */
export const COMPONENT_LIST = {
    MOBILE: 'mobile',
    ACCESSORIES: 'accessories',
    DSL: 'dsl',
    KABEL : 'kabel',
};
 /** API_HEADERS */
 export const API_HEADERS = {
    X_CAPTCHA: 'x-captcha',
    X_Captcha_Answer: 'X-Captcha-Answer',
    X_CONVERSATION_ID: 'x-conversation-id',
  };
/** PRODUCTS_ARRAY */
export const PRODUCTS = {
    TV : 'TV',
    INTERNET: 'Internet',
    DSL_INTERNET: 'DSL: Internet & Festnetz',
    OTHER: 'other',
};
/** TERMINATION_REASON_REVOKE */
export const TERMINATION_REASON_REVOKE = {
    REASON: 'widerruf',
};
/** TERMINATION_REASON_REVOKE */
export const TERMINATION_REASONS = {
    DEATH: 'Sterbefall',
    OTHER_REASON: 'Anderer Grund',
    UN_HAPPY_WITH_TARRIF: 'Ordentliche Kuendigung',
    TECHINCAL_ERROR: 'Ordentliche Kuendigung',
    DATE_PREFIX: 'Ausserordentliche Kuendigung',
};
/** TERMINATION_REASONS_VALUES */
export const TERMINATION_REASONS_VALUES = {
    DEATH: 'Sterbefall',
    OTHER_REASON: 'Anderer Grund',
    UN_HAPPY_WITH_TARRIF: 'Unzufrieden mit dem Tarif',
    TECHINCAL_ERROR: 'Unzufrieden mit Technik/Service',
    DATE_PREFIX: 'Ausserordendliche Kuendigung',
};
/** TERMINATION_REASON_REVOKE */
export const OPTION_PICKER_OTHER_OPTIONS = {
    DEATH: 'datePickerRadio',
    OTHER_REASON: 'terminationOtherReason',
    SPECIFY_DATE:'dsldatePickerRadio',
};
/** CAPTCHA TEXT TYPES */
export const CAPTCHA_TEXT_TYPES = {
    DEFAULT: 'default',
    UM_TERMINATE: 'umTerminate',
};
/** DEFAULT VALUES FOR PRINT TEMPLATE */
export const DEFAULT_VALUES_PRINT_TEMPLATE = {
    TERMINATION : 'terminate',
    REVOKATION : 'revoke',
};
/** Styles props for print screen components */
export const STYLES_PRINT_PAGE = {
    BLOCK : 'block',
    NONE : 'none',
    FIXED_POS : 'fixed' ,
    TOP : '-9999px',
    MAX_CONTENT_W : 'max-content',
    MAX_CONTENT_H  : 'max-content' ,
};
/** OVERVIEW_PAGE_PRINT_SCREEN */
export const OVERVIEW_PAGE_PRINT_SCREEN = {
    FILENAME: 'MeinVodafone',
    EXTENSION: '.pdf',
};
/** MAPPED_CUSTOMER_TYPE_KABLE */
export const MAPPED_CUSTOMER_TYPE_KABLE = {
    VKD : 'kd',
    UM : 'um',
};
/** MAPPED_CUSTOMER_TYPE_DSL */
export const MAPPED_CUSTOMER_TYPE_DSL = {
    DSL: 'dsl',

};
/** DOWNLOAD_TYPES */
export const DOWNLOAD_TYPES = {
    qrCode : 'qrCode',
    freightLabel: 'freightLabel',

};
/** DOWNLOAD_METHODS */
export const DOWNLOAD_METHODS = {
    EMAIL: 'email',
    DIRECT: 'direct',

};
/** TERMINATE_REASON_PAYLOAD  */
export const TERMINATE_REASON_PAYLOAD = {
    UM: {
        UNSATISFED_WITH_TARRIF: 'Kündigung ohne Grund (A)',
        UNSATISFED_WITH_SERVICE: 'Unzufrieden Technik/Service(A)',
        STERBEFALL: 'Kunde verstorben (A)',
        OTHER_REASON: '',
    },
    VKD: {
        UNSATISFED_WITH_TARRIF: 'Ohne Grund (gestaffelte Bestätigung)',
        UNSATISFED_WITH_SERVICE: 'Ohne Grund (gestaffelte Bestätigung)',
        STERBEFALL: 'Tod',
        OTHER_REASON: '',
    },
    DOD: 'Todestag',
    UNSATISFIED: {
        UNSATISFED_WITH_TARRIF: 'Unzufrieden mit dem Tarif',
        UNSATISFED_WITH_SERVICE: 'Unzufrieden mit Technik/Service',
    },
    DSL: {
        UNSATISFED_WITH_TARRIF: 'Ohne Grund (gestaffelte Bestätigung)',
        UNSATISFED_WITH_SERVICE: 'Ohne Grund (gestaffelte Bestätigung)',
        STERBEFALL: 'Tod',
        OTHER_REASON: '',
    },
};
